import React, { useState, useEffect } from 'react';
import { usersAPI } from '../../services/api';
import { toast } from 'react-toastify';
import Loading from '../../components/common/Loading';

const MyChannels = () => {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchChannels();
  }, []);

  const fetchChannels = async () => {
    try {
      setLoading(true);
      const response = await usersAPI.getMyChannels();
      setChannels(response.data.data || []);
    } catch (error) {
      toast.error('Erreur lors du chargement des chaînes');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Mes Chaînes</h1>
      {channels.length === 0 ? (
        <div style={styles.empty}>
          <p>Aucune chaîne assignée</p>
        </div>
      ) : (
        <div style={styles.grid}>
          {channels.map((channel) => (
            <div key={channel._id || channel.id} style={styles.card}>
              <h3 style={styles.cardTitle}>{channel.name}</h3>
              <p style={styles.cardDescription}>{channel.description}</p>
              <a
                href={channel.youtubeUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                Voir sur YouTube →
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 700,
    color: 'var(--text)',
    marginBottom: '2rem',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '1.5rem',
  },
  card: {
    background: 'white',
    borderRadius: '1rem',
    padding: '1.5rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  cardTitle: {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginBottom: '0.5rem',
  },
  cardDescription: {
    color: 'var(--text-light)',
    marginBottom: '1rem',
  },
  link: {
    color: 'var(--primary)',
    textDecoration: 'none',
    fontWeight: 500,
  },
  empty: {
    padding: '3rem',
    textAlign: 'center',
    color: 'var(--text-light)',
    background: 'white',
    borderRadius: '0.75rem',
  },
};

export default MyChannels;








